import type { IComponentController } from 'angular';
import template from './widget-categories-panel.component.html';
import type { WidgetCategory } from '../dashboard.service';
import { DashboardPageComponent, DashboardPageController } from '../dashboard-page/dashboard-page.component';

export class WidgetCategoriesPanelController implements IComponentController {
	page!: DashboardPageController;

	onCategoryClick(category: WidgetCategory) {
		this.page.applyCategory(category);
	}
}

export const WidgetCategoriesPanelComponent = {
	name: 'mxWidgetCategoriesPanel',
	controller: WidgetCategoriesPanelController,
	controllerAs: 'vm',
	template,
	require: {
		page: `^${DashboardPageComponent.name}`,
	},
};
